import shared from "../agencies-sections.module.css"

const Features = () => {
	return (
		<section className={shared.roiSection} aria-labelledby="agencies-roi-heading">
			<div className={`container ${shared.sectionContainer}`}>
				<header className={shared.roiHeader}>
					<div className={shared.label}>Impact</div>
					<h2 id="agencies-roi-heading">
						More revenue, less overhead.
						<br />
						The numbers tell the story.
					</h2>
				</header>

				<div className={shared.roiGrid}>
					<article className={shared.statCard}>
						<span className={shared.statValue}>70%</span>
						<p className={shared.statSummary}>saved on tool costs</p>
						<p className={shared.statDetail}>
							One platform replaces your resource planner, people directory, time and leave tracker, invoicing,
							and ATS. Less spend, less switching, less overhead.
						</p>
					</article>

					<article className={shared.statCard}>
						<span className={shared.statValue}>$50K+</span>
						<p className={shared.statSummary}>in additional annual revenue</p>
						<p className={shared.statDetail}>
							Your bench is no longer a cost centre. Our platform matches idle staff to startups actively looking
							to hire — turning downtime into billable work — no sales team required.
						</p>
					</article>

					<article className={shared.statCard}>
						<span className={shared.statValue}>$5K+</span>
						<p className={shared.statSummary}>monthly saved on prospecting</p>
						<p className={shared.statDetail}>
							Your senior consultants become discoverable to startups actively searching for niche expertise — warm
							leads, no business development required.
						</p>
					</article>

					<article className={shared.statCard}>
						<span className={shared.statValue}>40%</span>
						<p className={shared.statSummary}>less admin overhead</p>
						<p className={shared.statDetail}>
							Automated time tracking, project billing, and invoice generation mean your ops team spends less time
							on admin and more time on delivery.
						</p>
					</article>

					<article className={shared.statCard}>
						<span className={shared.statValue}>20%</span>
						<p className={shared.statSummary}>more operational efficiency</p>
						<p className={shared.statDetail}>
							Connected workflows across resourcing, delivery, and finance eliminate the manual handoffs that slow
							agencies down. Same team, measurably more output.
						</p>
					</article>

					<article className={shared.statCard}>
						<span className={shared.statValue}>2 weeks</span>
						<p className={shared.statSummary}>faster hiring cycle</p>
						<p className={shared.statDetail}>
							The built-in Recruiting module and TechCore Network mean you&apos;re sourcing, screening, and
							onboarding faster — without bouncing between tools or waiting on external recruiters.
						</p>
					</article>
				</div>
			</div>
		</section>
	)
}

export default Features
